import React, { useCallback, ChangeEvent } from 'react';
import styled from 'styled-components';
import ball from '../../../graphics/goal.svg';
import { FormControl, Select, MenuItem, FormControlLabel, Switch } from '@material-ui/core';
import TeamColorPicker from '../TeamColorPicker';
import { SessionInput } from '../../../services/sessions';
import { updateSessionFields } from '../../../services/sessions';
import { refreshSession } from '../../Util/useSession';
import { TSession } from '../Sessions';

interface Props {
  session?: TSession;
}

const SessionLineupsMetadata: React.FunctionComponent<Props> = ({ session }) => {
  const updateSession = useCallback(
    (update: SessionInput) => {
      if (session) {
        updateSessionFields(session, update).then(() => refreshSession(session.id));
      }
    },
    [session]
  );

  const onChangePlayers = useCallback(
    (event: ChangeEvent<any>) => {
      updateSession({ playerCount: event.target.value, keeperCount: 1 });
    },
    [updateSession]
  );

  return (
    <Wrapper>
      <Column>
        <Line>
          <Left style={{ overflow: 'visible', whiteSpace: 'nowrap', fontSize: 20 }}>
            <b>{session?.homeTeam?.name || ''}</b>
          </Left>
          <Middle />
          <Right />
        </Line>
        <Line>
          <Left>
            <FormControl fullWidth>
              <Select id="goalkeeper" value={1} disabled fullWidth>
                <MenuItem value={1}>1</MenuItem>
              </Select>
            </FormControl>
          </Left>
          <Middle>
            <span>Goalkeeper</span>
          </Middle>
          <Right>
            <TeamColorPicker
              color={session?.homeKeeperColor ? session?.homeKeeperColor : '#ffeb3b'}
              setColor={(newColor: string) => {
                updateSession({ homeKeeperColor: newColor });
              }}
            />
          </Right>
        </Line>
        <Line>
          <Left>
            <FormControl fullWidth>
              <Select id="player" value={session?.playerCount} fullWidth onChange={onChangePlayers}>
                <MenuItem value={1}>1</MenuItem>
                <MenuItem value={2}>2</MenuItem>
                <MenuItem value={3}>3</MenuItem>
                <MenuItem value={4}>4</MenuItem>
                <MenuItem value={5}>5</MenuItem>
                <MenuItem value={6}>6</MenuItem>
                <MenuItem value={7}>7</MenuItem>
                <MenuItem value={8}>8</MenuItem>
                <MenuItem value={9}>9</MenuItem>
                <MenuItem value={10}>10</MenuItem>
                <MenuItem value={11}>11</MenuItem>
                <MenuItem value={12}>12</MenuItem>
                <MenuItem value={13}>13</MenuItem>
                <MenuItem value={14}>14</MenuItem>
                <MenuItem value={15}>15</MenuItem>
                <MenuItem value={16}>16</MenuItem>
                <MenuItem value={17}>17</MenuItem>
                <MenuItem value={18}>18</MenuItem>
                <MenuItem value={19}>19</MenuItem>
                <MenuItem value={20}>20</MenuItem>
              </Select>
            </FormControl>
          </Left>
          <Middle>
            <span>Players</span>
          </Middle>
          <Right>
            <TeamColorPicker
              color={session?.homePlayerColor ? session?.homePlayerColor : '#ff1616'}
              setColor={(newColor: string) => {
                updateSession({ homePlayerColor: newColor });
              }}
            />
          </Right>
        </Line>
      </Column>
      <Column>
        <Line>
          <Left style={{ overflow: 'visible', whiteSpace: 'nowrap', fontSize: 20 }}>
            <b>{session?.awayTeam?.name || ''}</b>
          </Left>
          <Middle />
          <Right />
        </Line>
        <Line>
          <Left>
            <FormControl fullWidth>
              <Select id="goalkeeper" value={1} disabled fullWidth>
                <MenuItem value={1}>1</MenuItem>
              </Select>
            </FormControl>
          </Left>
          <Middle>
            <span>Goalkeeper</span>
          </Middle>
          <Right>
            <TeamColorPicker
              color={session?.awayKeeperColor ? session?.awayKeeperColor : '#8bc34a'}
              setColor={(newColor: string) => {
                updateSession({ awayKeeperColor: newColor });
              }}
            />
          </Right>
        </Line>
        <Line>
          <Left>
            <FormControl fullWidth>
              <Select id="player" value={session?.playerCount} fullWidth onChange={onChangePlayers}>
                <MenuItem value={1}>1</MenuItem>
                <MenuItem value={2}>2</MenuItem>
                <MenuItem value={3}>3</MenuItem>
                <MenuItem value={4}>4</MenuItem>
                <MenuItem value={5}>5</MenuItem>
                <MenuItem value={6}>6</MenuItem>
                <MenuItem value={7}>7</MenuItem>
                <MenuItem value={8}>8</MenuItem>
                <MenuItem value={9}>9</MenuItem>
                <MenuItem value={10}>10</MenuItem>
                <MenuItem value={11}>11</MenuItem>
                <MenuItem value={12}>12</MenuItem>
                <MenuItem value={13}>13</MenuItem>
                <MenuItem value={14}>14</MenuItem>
                <MenuItem value={15}>15</MenuItem>
                <MenuItem value={16}>16</MenuItem>
                <MenuItem value={17}>17</MenuItem>
                <MenuItem value={18}>18</MenuItem>
                <MenuItem value={19}>19</MenuItem>
                <MenuItem value={20}>20</MenuItem>
              </Select>
            </FormControl>
          </Left>
          <Middle>
            <span>Players</span>
          </Middle>
          <Right>
            <TeamColorPicker
              color={session?.awayPlayerColor ? session?.awayPlayerColor : '#3f51b5'}
              setColor={(newColor: string) => {
                updateSession({ awayPlayerColor: newColor });
              }}
            />
          </Right>
        </Line>
      </Column>
      <Column>
        <Line>
          <Left style={{ overflow: 'visible', whiteSpace: 'nowrap', fontSize: 20 }}>
            <b>Other</b>
          </Left>
          <Middle />
          <Right />
        </Line>
        <Line>
          <Left>
            <FormControl fullWidth>
              <Select id="referee" value={3} disabled fullWidth>
                <MenuItem value={3}>3</MenuItem>
              </Select>
            </FormControl>
          </Left>
          <Middle>
            <span>Officials</span>
          </Middle>
          <Right>
            <TeamColorPicker
              color={session?.refereeColor ? session?.refereeColor : '#607d8b'}
              setColor={(newColor: string) => {
                updateSession({ refereeColor: newColor });
              }}
            />
            <FormControlLabel disabled control={<Switch />} label="Include in output" />
          </Right>
        </Line>
        <Line>
          <Left>
            <FormControl fullWidth>
              <Select id="ball" value={1} disabled fullWidth>
                <MenuItem value={1}>1</MenuItem>
              </Select>
            </FormControl>
          </Left>
          <Middle>Ball</Middle>
          <Right>
            <Icon src={ball} />
          </Right>
        </Line>
      </Column>
    </Wrapper>
  );
};

const Column = styled.div`
  flex-grow: 1;
  display: flex;
  flex-direction: column;
  margin-right: 100px;
  &:last-child {
    margin-right: 0px;
  }
`;

const Wrapper = styled.div`
  display: flex;
  flex-direction: row;
`;

const Line = styled.div`
  display: flex;
  flex-direction: row;
`;

const Left = styled.div`
  padding: 10px;
  text-align: left;
  width: 80px;
  display: flex;
  align-items: center;
`;
const Middle = styled.div`
  padding: 10px;
  padding-top: 24px;
  text-align: left;
  width: 34%;
`;
const Right = styled.div`
  padding: 10px;
  text-align: left;
  display: flex;
  justify-content: left;
  width: 50%;
`;

const Icon = styled.img`
  width: 32px;
  margin: 8px;
`;

export default SessionLineupsMetadata;
